import { maxSizeDesktop, spacingExtraLarge, spacingMedium } from 'helpers/style';
import { Flex } from '../Flex';
import styled from '@emotion/styled';

export const ChartContainer = styled(Flex)`
    padding: ${spacingExtraLarge};
    ${maxSizeDesktop} {
        padding: ${spacingMedium};
    }
    background: ${(p) => p.theme.color.grayDark2};
    min-width: 100%;
`;

export const NoDataContainer = styled.div`
    position: absolute;
    width: 100%;
`;
